import * as Phaser from 'phaser';
import { bootPlayroom } from '@/net/PlayroomBridge';

/**
 * PreloadScene — draws a procedural loader while Playroom Kit negotiates the
 * lobby. There are no image assets to preload (ProceduralSpriteFactory draws
 * everything at runtime); all the wait time here is network.
 */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  create(): void {
    const { width, height } = this.scale;

    const title = this.add
      .text(width / 2, height / 2 - 120, 'CANDLE X', {
        fontFamily: 'IBM Plex Mono, monospace',
        fontSize: '56px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    title.setLetterSpacing?.(24);

    this.add
      .text(width / 2, height / 2 - 60, 'HUMANS vs ALIENS', {
        fontFamily: 'IBM Plex Mono, monospace',
        fontSize: '16px',
        color: '#9a9aa0',
      })
      .setOrigin(0.5)
      .setAlpha(0.9);

    // Razor-thin progress frame.
    const barW = 420;
    const barH = 2;
    const frame = this.add.graphics();
    frame.lineStyle(1, 0xffffff, 0.25);
    frame.strokeRect(width / 2 - barW / 2 - 2, height / 2 + 2, barW + 4, barH + 4);

    const bar = this.add.graphics();
    bar.fillStyle(0x1d6bff, 1);

    const status = this.add
      .text(width / 2, height / 2 + 40, 'ESTABLISHING TERAFAB LINK…', {
        fontFamily: 'IBM Plex Mono, monospace',
        fontSize: '12px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    status.setLetterSpacing?.(4);

    // Indeterminate sweep — real progress comes from the Playroom handshake.
    let t = 0;
    const tick = this.time.addEvent({
      delay: 16,
      loop: true,
      callback: () => {
        t = (t + 0.02) % 1;
        bar.clear();
        bar.fillStyle(0x1d6bff, 1);
        bar.fillRect(width / 2 - barW / 2, height / 2 + 3, barW * t, barH);
      },
    });

    bootPlayroom()
      .then(() => {
        tick.remove(false);
        status.setText('LINK ESTABLISHED');
        this.time.delayedCall(300, () => {
          this.scene.start('CommandHubScene');
          this.scene.launch('UIOverlayScene');
        });
      })
      .catch((err: unknown) => {
        console.error('[CandleX] Playroom boot failed', err);
        status.setText('LINK DEGRADED — ENTERING SOLO MODE');
        this.time.delayedCall(600, () => {
          this.scene.start('CommandHubScene');
          this.scene.launch('UIOverlayScene');
        });
      });
  }
}
